module.exports = __webpack_public_path__ + "static/media/DC_O_Jacquard_Palestro_DK Grey_Bordeaux.c6c44da2.png";